import { Pipe, PipeTransform } from '@angular/core'
import { Profile } from '../interfaces/user'
/**
 * quiz report 작성자 이름을 가져오는 pipe
 */
@Pipe({
  name: 'quizName',
})
export class QuizNamePipe implements PipeTransform {
  constructor() {}

  transform(
    value:
      | { isProfileHidden?: boolean; profile?: Profile; respondentFirstName?: string; isRemoved?: boolean }
      | undefined
  ): string {
    if (!value) {
      return ''
    }
    if (value.isRemoved) {
      return '상대방'
    }
    if (value.isProfileHidden) {
      return value.respondentFirstName ?? ''
    }
    return (value.profile ? value.profile.firstName : value.respondentFirstName) ?? ''
  }
}
